import React, { useState, useEffect } from 'react'
import { GoogleMapsProvider } from './google-maps-provider'

interface ClientOnlyGoogleMapsProviderProps {
    children: React.ReactNode
}

/**
 * Wrapper that only renders GoogleMapsProvider on the client side
 * to prevent SSR issues that can cause multiple script loading
 */
export const ClientOnlyGoogleMapsProvider: React.FC<
    ClientOnlyGoogleMapsProviderProps
> = ({ children }) => {
    const [isClient, setIsClient] = useState(false)

    useEffect(() => {
        setIsClient(true)
    }, [])

    // During SSR or before hydration, render children without GoogleMapsProvider
    if (!isClient) {
        return <>{children}</>
    }

    // On client side, wrap with GoogleMapsProvider
    return <GoogleMapsProvider>{children}</GoogleMapsProvider>
}
